import { j as o } from "./index58.mjs";
import { Tooltip as e } from "@mantine/core";
import { forwardRef as i } from "react";
const c = i((s, l) => {
  const t = {
    label: "",
    multiline: !0,
    withinPortal: !0,
    classNames: {
      tooltip: "max-w-xs"
    }
  };
  return /* @__PURE__ */ o.jsx(
    e,
    {
      ...t,
      ...s,
      classNames: { ...t.classNames, ...s.classNames },
      children: /* @__PURE__ */ o.jsx("div", { ref: l, children: s.children })
    }
  );
});
export {
  c as Tooltip
};
